import { render, staticRenderFns } from "./purchase-order-form.vue?vue&type=template&id=0d8d438e"
import script from "./purchase-order-form.vue?vue&type=script&lang=js"
export * from "./purchase-order-form.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports